import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface SaveTemplateRequest {
  query: string;
  extra_instructions: string;
  deep_mode: boolean;
  visibility: 'private' | 'team' | 'recommended';
}

const saveAnalysisTemplate = async (data: SaveTemplateRequest): Promise<any> => {
  const response = await instance.post('/nexa/analysis-templates', data);
  return response.data;
};

export const useSaveAnalysisTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveAnalysisTemplate,
    onSuccess: () => {
      message.success('Analysis template saved successfully');
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: ['analysis-templates'] });
      queryClient.invalidateQueries({ queryKey: ['analysis-tags'] });
      queryClient.invalidateQueries({ queryKey: ['my-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['team-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['recommended-analyses'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.error?.message || 'Failed to save analysis template', 5);
    },
  });
};
